
export enum APP_CONTEXT {
  Default = 'Default',
  Talent = 'Talent',
  Recruiter = 'Recruiter',
  Auth = 'Auth',
  Admin = 'Admin'
}
